var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKotlinLanguageIcon = function SvgKotlinLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 21H3V3h18l-9 9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4b9c0",
    d: "M21 3h-9l9 9z"
  })));
};
export default SvgKotlinLanguageIcon;